import { apiConfigActions } from "./apiConfig-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

// const url_data = "/config/apiConfig.json";

export const fetchApiConfigData = (url_data, autenticationData) => {

	console.log("fetchApiConfigData", autenticationData)

	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, autenticationData);
			
			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const apiConfigData = await fetchData();
			dispatch(apiConfigActions.updateApiConfig(apiConfigData));
		} catch (error) {
			console.log(error);
		}
	};
};